const fontSizes = {
    "1": "8px",
    "2": "10px",
    "3": "12px",
    "4": "14px",
    "5": "16px",
    "6": "18px",
    "7": "20px",
    "8": "22px",
    "9": "24px",
    "10": "26px",
    "11": "28px",
    "12": "30px",
    "13": "32px",
    "14": "34px",
    "15": "36px",
    "16": "38px",
    "17": "40px",
    "18": "42px",
    "19": "44px",
    "20": "46px",
    "21": "48px",
    "22": "50px",
    "23": "52px",
    "24": "54px",
    "25": "56px",
    "26": "58px",
    "27": "60px",
    "28": "62px",
    "29": "64px",
    "30": "66px",
    "31": "68px",
    "32": "70px",
};
export default fontSizes;
//# sourceMappingURL=fontSizes.js.map